export default __webpack_public_path__ + "static/media/mondelez.2da0186e.svg";